export const routes = {
    main: "/",
}
